import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEM_ALARM_PERIODIC_UPDATED} from "../actions/system_alarm_periodic";

const state = {
    system_alarm_periodic: []
};

const actions = {
    getSysAlarm: ({commit, rootGetters}) => {
        axios({url: api.url + 'sysAlarmPeriodic?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('SYSTEM_ALARM_PERIODIC_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
    //recupère un periodic_alarm sur un system
    getSysPeriodic: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
          axios({url: api.url + 'sysAlarmPeriodic?system_id=' + payload.system_id, method: 'GET'})
            .then(resp => {
              commit('SYSTEM_ALARM_PERIODIC_UPDATED', resp.data);
              resolve(resp.data); // résoudre la promesse avec la réponse
            })
            .catch(err => {
              reject(err); // rejeter la promesse avec l'erreur
            });
        });
    },
    refresh({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(api.url + 'sysAlarmPeriodic?id=' + payload.id, {
                
            })
            .then((response) => {
                commit('removeSysAlarmPeriodic', payload.id);
                commit('addSysAlarmPeriodic', response.data);
                resolve(response.data);
            })
            .catch((error) => {
                reject({ status : error.response.status })
            })
        });
    },
    update({commit}, payload) {
        const params = new URLSearchParams();
        params.append('unit_type', payload.unit_type);
        params.append('dest_id', payload.dest_id);
        params.append('periodicity', payload.periodicity);
        params.append('alarm_name', payload.alarm_name);
        
       
    
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'sysAlarmPeriodic/' + payload.id, params)
            .then((response) => {
                //commit('SYSTEM_ALARM_PERIODIC_UPDATED', response.data);
                commit('removeSysAlarm', payload.id);
                commit('addSysAlarm', response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    create({commit, rootGetters}, payload) {
        
        const params = new URLSearchParams();
        params.append('unit_type', payload.unit_type);
        params.append('dest_id', payload.dest_id);
        params.append('periodicity', payload.periodicity);
        params.append('alarm_name', payload.alarm_name);
        params.append('system_id', payload.system_id);
        params.append('structure_id', rootGetters.structure_id);

        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'sysAlarmPeriodic', params)
            .then((response) => {
                
                commit('addSysAlarm', response.data);
                commit('removeSysAlarm', -1);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
    },
};
const mutations = {
    [SYSTEM_ALARM_PERIODIC_UPDATED]: (state, system_alarm_periodic) => {
        state.system_alarm_periodic = system_alarm_periodic;
    },
    ['addSysAlarm']: (state, alarm) => {
        state.system_alarm_periodic.push(alarm);
    },
    ['removeSysAlarm']: (state, id) => {
        var index = state.system_alarm_periodic.findIndex(event => event.id === id);
        state.system_alarm_periodic.splice(index, 1);
    },
    
};


const getters = {
    system_alarm_periodic : state => state.system_alarm_periodic,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
